"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnCanvasMouseEvent = void 0;
/**
 * @public
 * Provides raw mouse events. Shouldn't typically be used unless implementing custom interaction handler.
 */
class OnCanvasMouseEvent {
    constructor(onMouseEvent) {
        this.onMouseEvent = onMouseEvent;
    }
    static registerListener(eventService, onEvent) {
        return eventService
            .getCategory(OnCanvasMouseEvent)
            .addTemporaryListener(new OnCanvasMouseEvent(onEvent));
    }
    static emit(eventService, eventType, $event) {
        const listeners = eventService
            .getCategory(OnCanvasMouseEvent)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onMouseEvent(eventType, $event);
        }
    }
}
exports.OnCanvasMouseEvent = OnCanvasMouseEvent;
OnCanvasMouseEvent.callbackKey = "onMouseEvent";
//# sourceMappingURL=on-canvas-mouse-event.js.map